export default ".checkride-item-container {\n  border: 2px solid black;\n  border-radius: 5px;\n  padding: 10px;\n  width: 100%;\n  margin-bottom: 10px;\n}";